import { ImageDimensions } from './image-dimensions.model';

export class ImageData {
    /** @deprecated Nothing reads this, and several entries share or omit a value. Removed in the next major. */
    id: string;
    dimensions: [ImageDimensions, ImageDimensions, ImageDimensions, ImageDimensions, ImageDimensions];

    constructor(
        id: string,
        dimensions: [ImageDimensions, ImageDimensions, ImageDimensions, ImageDimensions, ImageDimensions]
    ) {
        this.id = id;
        this.dimensions = dimensions;
    }
}
